import { useToast } from '@fukuri-admins/ui/common/Toast/hooks';
import { useGetStressAssessmentUserReportList } from '../../../hooks/useGetStressAssessmentUserReportList';
import { useGetStressAssessmentList } from './useGetStressAssessmentList';
import { usePostStressAssessmentReminders } from './usePostStressAssessmentReminders';

type Args = {
  threeLetterCode: string;
  stressAssessmentId: number;
};

type IUseRemindModal = (args: Args) => {
  handleRemind: () => void;
  dueDate: number | undefined;
  pendingCount: number;
};

export const useRemindModal: IUseRemindModal = ({ threeLetterCode, stressAssessmentId }) => {
  const { showToast } = useToast();

  const { trigger } = usePostStressAssessmentReminders(threeLetterCode, stressAssessmentId, {
    swr: {
      onSuccess: () => {
        showToast({
          message: '未回答者に再送信しました。',
        });
      },
      onError: () => {
        showToast({
          message: '未回答者に再送信できませんでした。',
          status: 'danger',
        });
      },
    },
  });

  // ストレスチェック一覧から回答期限を取得
  const { data: stressAssessmentListData } = useGetStressAssessmentList(threeLetterCode);
  const currentStressAssessment = stressAssessmentListData?.stress_assessments.find(
    sa => sa.id === stressAssessmentId
  );

  // 未回答者数を取得（pendingフィルターのデータ数）
  const { data: pendingData } = useGetStressAssessmentUserReportList(threeLetterCode, {
    stressAssessmentId,
    filter: 'pending',
    page: '1',
  });
  const pendingCount = pendingData?.stress_assessment_results?.length ?? 0;

  return {
    handleRemind: trigger,
    dueDate: currentStressAssessment?.due_date,
    pendingCount,
  };
};
